import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { UtilityService } from 'app/services/utility.service';
import { BsModalService } from 'ngx-bootstrap';
import { ApiService } from 'app/services/api.service';
import { I18nPipe } from 'app/shared/i18n/i18n.pipe';
import { ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-translation',
  templateUrl: './translation.component.html',
  styleUrls: ['./translation.component.scss']
})
export class TranslationComponent implements OnInit {
  dataList: Array<any>;
  modalRef;
  config = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };
  formObj: any = {};
  public inputFiledOld = '';
  public inputField = '';
  public inputFieldFr = '';
  public inputFieldDe = '';
  isEdit = false;
  editId = '';
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  translationList: any = [];

  constructor(private utilityService: UtilityService, private modalService: BsModalService, private apiService: ApiService,
    private localize: I18nPipe, private route: ActivatedRoute,  private spinner: NgxSpinnerService) {
    this.utilityService.breadcrumb = 'Translation';
    this.utilityService.breadcrumbList = ['Settings', 'Translation'];
    this.getTranslation();
  }

  ngOnInit() {
    this.spinner.show();
  }

  getTranslation() {
    this.apiService.get('/translation').subscribe((translations: any) => {
      this.translationList = translations;
      this.spinner.hide();
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }


  openEditDialog(template, obj, type) {
    if(type == "New") {
      this.resetInputFields();
    } else if(type == "Edit") {
      this.isEdit = true;
      this.formObj = obj;
      this.inputFiledOld = obj.en;;
      this.inputField = this.formObj.en;
      this.inputFieldDe = this.formObj.de;
      this.inputFieldFr = this.formObj.fr;
    }
    this.openModal(template);
  }

  saveTranslation() {
    if (this.inputField == '' || this.inputField == undefined || this.inputFieldDe == '' || this.inputFieldDe == undefined) {
      this.showNotification('Warning', 'Please provide english and deutsch language.', 'warning');
    } else {
      this.spinner.show();
      this.apiService.post('/translation', {
        en: this.inputField,
        de: this.inputFieldDe,
        fr: this.inputFieldFr 
      }).subscribe((response: any) => {
        this.translationList.push({"en": this.inputField, "de": this.inputFieldDe, "fr": this.inputFieldFr});
        this.refreshGrid();
        this.closeModel();
        this.spinner.hide();
        this.showNotification('Success', 'Translation save successfully.', 'success');
      });
    }
  }

  updateTranslation() {
    if (this.inputField == '' || this.inputField == undefined || this.inputFieldDe == '' || this.inputFieldDe == undefined) {
      this.showNotification('Warning', 'Please provide english and deutsch language.', 'warning');
    } else {
      this.spinner.show();
      this.apiService.put('/translation', {
        enOld: this.inputFiledOld,
        en: this.inputField,
        de: this.inputFieldDe,
        fr: this.inputFieldFr 
      }).subscribe((response: any) => {
        let transObj = this.translationList.find(val => val.en == this.inputFiledOld);
        if (transObj != undefined && transObj != null) {
          transObj.en = this.inputField;
          transObj.de = this.inputFieldDe;
          transObj.fr = this.inputFieldFr;
        }
        this.refreshGrid();
        this.closeModel();
        this.spinner.hide();
        this.showNotification('Success', 'Translation updated successfully.', 'success');
      });
    }
  }

  deleteTranslation(obj) {
    let msg = 'Are you sure you want to delete?';

    swal({
      title: `${this.localize.transform('Confirmation')}`,
      text: `${this.localize.transform(msg)}`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: `${this.localize.transform('Yes')}`,
      cancelButtonText: `${this.localize.transform('No')}`,
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.formObj = obj;
        this.spinner.show();
        this.apiService.delete('/translation/' + this.formObj.en).subscribe((response: any) => {
          let transObj = this.translationList.find(val => val.en == this.formObj.en);
          let idx = this.translationList.indexOf(transObj);
          this.translationList.splice(idx, 1)
          this.refreshGrid();
          this.resetInputFields();
          this.spinner.hide();
          this.showNotification('Success', 'Translation deleted successfully.', 'success');
        });
      }
    });
  }

  resetInputFields() {
    this.isEdit = false;
    this.inputField = '';
    this.inputFieldDe = '';
    this.inputFieldFr = '';
    this.inputFiledOld = '';
    this.formObj = {};
  }

  showNotification(title, message, type) {
    this.utilityService.showNotification(
      this.localize.transform(title),
      this.localize.transform(message),
      type,
    );
  }

  closeModel(){
    this.resetInputFields();
    this.modalRef.hide();
  }

  refreshGrid() {
    this.dataGrid.instance.option('dataSource', this.translationList);
  }

}
